<!-- 新增 / 编辑 直播 -->
<template>
  <div class="apply">
    <back />

    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" class="demo-ruleForm">
      <div class="form">
        <div class="title">基础信息：</div>
        <el-divider class="dividers"></el-divider>
        <div class="container">
          <el-form-item class="item" label="直播间名称：" prop="liveName">
            <el-input v-model="ruleForm.liveName" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="item" label="直播间分类：" prop="categoryId">
            <el-select v-model="ruleForm.categoryId" placeholder="请选择" clearable>
              <el-option v-for="item in categoryOptions" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="item" label="直播主讲专家：" prop="teacherId">
            <el-select v-model="ruleForm.teacherId" placeholder="请选择" clearable @change="handleSelectTeacher">
              <el-option v-for="item in teacherNameOptions" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="item" label="是否收费：" prop="costAttr">
            <el-select v-model="ruleForm.costAttr" placeholder="请选择" clearable>
              <el-option v-for="item in costAttrOptions" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="item" label="直播价格：" prop="price" v-if="ruleForm.costAttr == 1">
            <el-input v-model="ruleForm.price" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="item" label="开播时间：" prop="startTime">
            <el-date-picker v-model="ruleForm.startTime" type="datetime" placeholder="请选择"
              :picker-options="pickerOptions" value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item class="item" label="结束时间：" prop="endTime">
            <el-date-picker v-model="ruleForm.endTime" type="datetime" placeholder="请选择" :picker-options="pickerOptions"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item class="item" label="是否推荐：" prop="recommendFlag">
            <el-select v-model="ruleForm.recommendFlag" placeholder="请选择" clearable>
              <el-option v-for="item in recommendOptions" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="item logo_pic" label="直播间封面：" prop="livePic">
            <el-upload class="logo_uploader" accept=".png,.jpeg,.jpg" name="multipartFile" :action="action"
              :show-file-list="false" :on-success="handleSuccess" :before-upload="beforeUploads"
              :on-remove="handleRemoveLogo" :disabled="ruleForm.livePic ? true : false" :headers="headers">
              <img v-if="ruleForm.livePic" :src="ruleForm.livePic" class="logoimg">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <i v-if="ruleForm.livePic" class="delpic el-icon-error" @click="handleRemoveLogo"></i>
          </el-form-item>
        </div>

        <div class="title">开播信息：</div>
        <el-divider class="dividers"></el-divider>
        <div class="container">
          <el-form-item class="item" label="PC直播Url：" prop="liveUrl">
            <el-input v-model="ruleForm.liveUrl" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="item" label="PC直播频道号：" prop="channelNumber">
            <el-input v-model="ruleForm.channelNumber" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="item" label="PC直播登录密码：" prop="livePassword">
            <el-input v-model="ruleForm.livePassword" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="item logo_pic" label="小程序开播二维码：" prop="mpLiveUrl">
            <el-upload class="logo_uploader" accept=".png,.jpeg,.jpg" name="multipartFile" :action="action"
              :show-file-list="false" :on-success="handleSuccess2" :before-upload="beforeUploads"
              :on-remove="handleRemoveLogo2" :disabled="ruleForm.mpLiveUrl ? true : false" :headers="headers">
              <img v-if="ruleForm.mpLiveUrl" :src="ruleForm.mpLiveUrl" class="logoimg">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <i v-if="ruleForm.mpLiveUrl" class="delpic el-icon-error" @click="handleRemoveLogo2"></i>
          </el-form-item>
        </div>
        <div class="title">观看信息:</div>
        <el-divider class="dividers"></el-divider>
        <div class="container">
          <el-form-item class="item" label="H5观看Url：" prop="playUrl">
            <el-input v-model="ruleForm.playUrl" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="item" label="小程序观看地址：" prop="mpPlayUrl">
            <el-input v-model="ruleForm.mpPlayUrl" placeholder="请输入"></el-input>
          </el-form-item>
        </div>

        <div class="title">积分设置:</div>
        <el-divider class="dividers"></el-divider>
        <div class="container">
          <el-form-item class="item" label="观看可获得积分：" prop="watchPoints">
            <el-input v-model="ruleForm.watchPoints" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="item" label="分享可获得积分：" prop="sharePoints">
            <el-input v-model="ruleForm.sharePoints" placeholder="请输入"></el-input>
          </el-form-item>
        </div>

        <div class="title">直播间介绍:</div>
        <el-divider class="dividers"></el-divider>
        <div class="container">
          <el-form-item class="" label="" prop="introduce" label-width="80px">
            <editor :htmls="ruleForm.introduce" @change="onChange" />
          </el-form-item>
        </div>
        <div class="submit-btn">
          <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import editor from "@/components/editor.vue"
export default {
  components: {
    editor
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          const now = new Date()
          now.setHours(0, 0, 0, 0)
          const targetDate = new Date(time)
          targetDate.setHours(0, 0, 0, 0)
          return targetDate < now
        },
      },
      categoryOptions: [], // 分类options
      teacherNameOptions: [], // 专家options
      // 是否推荐options
      recommendOptions: [{
        label: '是',
        value: 1
      },
      {
        label: '否',
        value: 0
      },
      ],
      // 是否收费options
      costAttrOptions: [{
        label: '是',
        value: 1
      },
      {
        label: '否',
        value: 0
      },
      ],
      ruleForm: {
        liveName: '',
        categoryId: '',
        teacherId: '',
        costAttr: 1,
        price: '',
        startTime: '',
        endTime: '',
        liveUrl: '',
        playUrl: '',
        recommendFlag: '',
        livePic: '',
        introduce: '',

        channelNumber: '',
        livePassword: '',
        mpLiveUrl: '',
        mpPlayUrl: '',

        watchPoints: '',
        sharePoints: '',
      },
      rules: {
        liveName: [{
          required: true,
          message: '请输入直播间名称',
          trigger: 'blur'
        }],
        categoryId: [{
          required: true,
          message: '请选择直播间分类',
          trigger: 'blur'
        }],
        teacherId: [{
          required: true,
          message: '请选择直播主讲专家',
          trigger: 'blur'
        }],
        costAttr: [{
          required: true,
          message: '请选择是否收费',
          trigger: 'blur'
        }],
        price: [{
          required: true,
          message: '请输入直播价格',
          trigger: 'blur'
        }, {
          pattern: /^\d+(\.\d{1,2})?$/,
          message: '只能输入数字',
          trigger: 'blur'
        }],
        startTime: [{
          required: true,
          message: '请选择开播时间',
          trigger: 'blur'
        }],
        endTime: [{
          required: true,
          message: '请选择结束时间',
          trigger: 'blur'
        }, {
          validator: (rule, value, callback) => {
            if (!value) {
              return callback();
            }
            if (this.ruleForm.startTime && new Date(value).getTime() <= new Date(this.ruleForm.startTime).getTime()) {
              callback(new Error('结束时间不能早于或等于开播时间'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        liveUrl: [{
          required: true,
          message: '请输入PC直播Url',
          trigger: 'blur'
        }],
        playUrl: [{
          required: true,
          message: '请输入H5观看Url',
          trigger: 'blur'
        }],
        recommendFlag: [{
          required: true,
          message: '请选择是否推荐',
          trigger: 'blur'
        }],
        livePic: [{
          required: true,
          message: '请上传直播间封面',
          trigger: 'blur'
        }],
        introduce: [{
          required: true,
          message: '请输入直播间介绍',
          trigger: 'blur'
        }],
        channelNumber: [
          { required: true, message: '请输入PC直播频道号', trigger: 'blur' },
          {
            pattern: /^[^\u4e00-\u9fa5]+$/,
            message: '不能包含中文',
            trigger: 'blur'
          }
        ],
        livePassword: [
          { required: true, message: '请输入PC直播登录密码', trigger: 'blur' },
          {
            pattern: /^[^\u4e00-\u9fa5]+$/,
            message: '不能包含中文',
            trigger: 'blur'
          }
        ],
        mpLiveUrl: [{
          required: true,
          message: '请上传小程序开播二维码',
          trigger: 'blur'
        }],
        mpPlayUrl: [{
          required: true,
          message: '请输入小程序观看地址',
          trigger: 'blur'
        }],
        watchPoints: [{
          required: true,
          message: '请输入观看可获得积分',
          trigger: 'blur'
        }, {
          pattern: /^\d+(\.\d{1,2})?$/,
          message: '只能输入数字',
          trigger: 'blur'
        }],
        sharePoints: [{
          required: true,
          message: '请输入分享可获得积分',
          trigger: 'blur'
        }, {
          pattern: /^\d+(\.\d{1,2})?$/,
          message: '只能输入数字',
          trigger: 'blur'
        }],
      },
      // 图片上传
      action: this.$axios.defaults.baseURL + this.$api.uploadFile,
      headers: {
        token: this.$store.state.token,
      },
    }
  },
  beforeRouteEnter(to, from, next) {
    if (to.query.id) {
      to.meta.title = "编辑直播";
    } else {
      to.meta.title = "新增直播";
    }
    next();
  },
  mounted() {
    document.title = this.$route.meta.title;
  },
  watch: {
    '$route'(to, from) {
      document.title = to.meta.title;
    },
    'ruleForm.costAttr': function (newVal) {
      if (newVal == 0) { // 如果选择了免费课程
        this.ruleForm.price = 0;
      }
    }
  },
  created() {
    if (this.$route.query.id) {
      this.selectLiveInfoDetail()
    }
    this.selectListByTeacher()
    this.getCategoryList()
  },

  methods: {
    onChange(value) {
      this.ruleForm.introduce = value
    },
    // 分类
    getCategoryList() {
      this.$axios
        .get(this.$api.getLiveCategoryList, {
          params: {
            page: 1,
            pageSize: 9999,
          },
        })
        .then(res => {
          if (res.code == 100) {
            this.categoryOptions = res.result.map(item => {
              return {
                label: item.categoryName,
                value: item.id
              }
            })
          }
        })
        .catch(err => {
          this.$message.error(err.desc)
        })
    },
    selectListByTeacher() {
      this.$axios
        .get(this.$api.selectListByTeacher)
        .then(res => {
          if (res.code == 100) {
            this.teacherNameOptions = res.result.map(item => {
              return {
                label: item.teacherName,
                value: item.id
              }
            })
          }
        })
        .catch(err => {
          this.$message.error(err.desc)
        })
    },
    // 编辑详情
    selectLiveInfoDetail() {
      this.$axios
        .get(this.$api.selectLiveInfoDetail, {
          params: {
            id: this.$route.query.id,
          },
        })
        .then(res => {
          if (res.code === 100) {
            const row = res.result
            this.ruleForm = row
            this.$set(this.ruleForm, "introduce", row.introduce)
          }
        })
        .catch(err => {
          this.$message.error(err.desc)
        })
    },
    handleSelectTeacher(value) {
      const selectedTeacher = this.teacherNameOptions.find(item => item.value === value);
      if (selectedTeacher) {
        this.ruleForm.teacherName = selectedTeacher.label;
      }
    },
    // 表单校验
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // if (this.ruleForm.costAttr == 1 && parseFloat(this.ruleForm.price) == 0) {
          //   this.$message.warning("付费状态下，价格不能为0");
          //   return;
          // }
          if (this.ruleForm.costAttr == 0) {
            this.ruleForm.price = 0;
          }
          // if (this.ruleForm.costAttr == 0 && parseFloat(this.ruleForm.price) != 0) {
          //   this.$message.warning("免费状态下，价格只能为0");
          //   return;
          // }
          const formData = {
            costAttr: this.ruleForm.costAttr,
            categoryId: this.ruleForm.categoryId,
            endTime: this.ruleForm.endTime || null,
            introduce: this.ruleForm.introduce || null,
            liveName: this.ruleForm.liveName || null,
            livePic: this.ruleForm.livePic || null,
            playUrl: this.ruleForm.playUrl || null,
            liveUrl: this.ruleForm.liveUrl || null,
            price: this.ruleForm.price,
            startTime: this.ruleForm.startTime || null,
            teacherName: this.ruleForm.teacherName || null,
            teacherId: this.ruleForm.teacherId || null,
            recommendFlag: this.ruleForm.recommendFlag,
            channelNumber: this.ruleForm.channelNumber,
            livePassword: this.ruleForm.livePassword,
            mpLiveUrl: this.ruleForm.mpLiveUrl,
            mpPlayUrl: this.ruleForm.mpPlayUrl,
            watchPoints: this.ruleForm.watchPoints,
            sharePoints: this.ruleForm.sharePoints,
          }
          if (this.$route.query.id) {
            // 如果存在 this.$router.query.id
            formData.id = this.$route.query.id
            this.$axios
              .post(this.$api.updateLiveInfo, formData)
              .then(res => {
                if (res.code == 100) {
                  this.$message.success(res.desc)
                  this.$router.go(-1)
                  this.resetForm()
                }
              })
              .catch(err => {
                this.$message.error(err.desc)
              })
          } else {
            // 否则调用添加接口 insertLiveInfo
            this.$axios
              .post(this.$api.insertLiveInfo, formData)
              .then(res => {
                if (res.code == 100) {
                  this.$message.success(res.desc)
                  this.$router.go(-1)
                  this.resetForm()
                }
              })
              .catch(err => {
                this.$message.error(err.desc)
              })
          }
        } else {
          console.log("error submit!!")
          return false
        }
      })
    },
    // 重置表单
    resetForm() {
      this.ruleForm = {}
      this.$refs.ruleForm.resetFields()
    },
    // 文件上传前
    beforeUploads(file) {
      const isJPG = file.type === "image/jpeg" || "image/jpg" || "image/png"
      // const isLt5M = file.size / 1024 / 1024 < 5
      if (!isJPG) {
        this.$message.error("图文只支持jpg、png、jpeg，请调整格式再上传!")
      }
      // if (!isLt5M) {
      //   this.$message.error("上传图片大小不能超过 5MB!")
      // }
      // return isJPG && isLt5M
      return isJPG
    },
    handleRemoveLogo() {
      this.ruleForm.livePic = ""
    },
    handleSuccess(res) {
      if (res.code == 100) {
        this.ruleForm.livePic = res.result.fileUrl;
      } else {
        this.$message({
          showClose: true,
          message: res.desc,
          type: "error",
        });
      }
    },
    handleRemoveLogo2() {
      this.ruleForm.mpLiveUrl = ""
    },
    handleSuccess2(res) {
      if (res.code == 100) {
        this.ruleForm.mpLiveUrl = res.result.fileUrl;
      } else {
        this.$message({
          showClose: true,
          message: res.desc,
          type: "error",
        });
      }
    },
  },
}
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="scss" scoped>
.form {
  margin: 30px 20px;

  .title {
    font-size: 18px;
    margin-left: 60px;
    font-weight: bold;
  }

  .dividers {
    background-color: #f0f1f1;
  }

  .container {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 30px;
    font-size: 16px;
    color: #707070;

    ::v-deep .el-form-item__label {
      color: #272727;
      font-size: 16px;
      padding-right: 15px;
    }

    .el-input,
    .el-select,
    .el-cascader,
    .el-date-editor {
      width: 300px;
    }
  }

  .item {
    width: 30%;
    /* 100% / 3 = 33.33%，留一点空间避免浏览器计算误差 */
    margin-bottom: 30px;
    margin-right: 30px;
  }

  .container .item:nth-last-child(-n+3) {
    margin-bottom: 0;
  }
}

.submit-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 100px;
}


// 图片
.logo_pic {
  position: relative;

  ::v-deep .el-form-item__content {
    width: 100px;
    height: 100px;
  }

  .logo_uploader {
    ::v-deep .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }

    ::v-deep .el-upload:hover {
      border-color: $themes;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: $themes;
      width: 100px;
      height: 100px;
      line-height: 100px;
      text-align: center;
    }

    .logoimg {
      width: 100px;
      height: 100px;
      display: block;
      object-fit: cover;
    }
  }

  .delpic {
    position: absolute;
    top: -12px;
    left: 90px;
    color: red;
    font-size: 20px;
    cursor: pointer;
  }
}
</style>
